// imports
import _get from 'lodash/get';
import _map from 'lodash/map';

import Config from '$root/Config';
import BinSmallModel from '$models/bin/BinSmallModel';
import binDrupalFilterParent from '$models/bin/binDrupalFilterParent';
import MMCollection from './MMCollection';

export default class GarbageBinSmallCollection extends MMCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinSmallModel;
		args.parentModel = binDrupalFilterParent();
		args.useProQueryParams = true;
		// call super constructor
		super(args);

		this.setCallFilter({
			status: {
				value: [true],
			},
		});
		this.setConfig('params', { count: 'all', format: 'geojson' });
	}

	parse(data) {
		const markers = _get(data, 'features');
		data = _map(markers, (item) => {
			const preparedItem = {
				id: _get(item, 'properties.uuid') || _get(item, 'properties.id') || _get(item, 'id'),
				title: _get(item, 'properties.title'),
				gId: _get(item, 'properties.field_bin_g_id')
					|| _get(item, 'properties.customBinId')
					|| _get(item, 'properties.binId')
					|| _get(item, 'properties.gId'),
				parentModel: {},
			};

			// create model
			const newModel = new this.Model().set(preparedItem);
			return newModel;
		});
		return super.parse(data);
	}

	fetch() {
		this.setConfig('url', Config.getUrl('binsGeoJson'));
		this.setConfig('params', { count: 'all', format: 'geojson' });
		return super.fetch();
	}
}
